import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "footer-text-container" }
const _hoisted_3 = {
  class: "footer-item",
  style: {"text-align":"left"}
}

import {
  CustomerServiceFilled,
  EnvironmentFilled,
  MailFilled,
  PhoneFilled,
  PrinterFilled,
} from "@ant-design/icons-vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"footer-item\" data-v-7e9ff0f8><div class=\"footer-title\" data-v-7e9ff0f8>礼邦物流</div><p data-v-7e9ff0f8>订舱</p><p data-v-7e9ff0f8>报关</p><p data-v-7e9ff0f8>运输</p><p data-v-7e9ff0f8>仓储</p><p data-v-7e9ff0f8>堆场</p></div><div class=\"footer-item\" data-v-7e9ff0f8><div class=\"footer-title\" data-v-7e9ff0f8>上海物流运输</div><div data-v-7e9ff0f8>上海礼邦物流有限公司</div><div data-v-7e9ff0f8>REPPON LOGISTICS</div></div><div class=\"footer-item\" data-v-7e9ff0f8><div class=\"footer-title\" data-v-7e9ff0f8>技术支持</div><div data-v-7e9ff0f8>新链科技</div></div>", 3)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createVNode(_unref(EnvironmentFilled)),
          _cache[0] || (_cache[0] = _createTextVNode(" 地址: 上海市宝山区同济路669弄（宝杨宝龙广场）T3写字楼1002-1003室 "))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(PhoneFilled)),
          _cache[1] || (_cache[1] = _createTextVNode(" 电话: 86-021-56493583 "))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(MailFilled)),
          _cache[2] || (_cache[2] = _createTextVNode(" 邮箱: shangjingxin@reppon.com "))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(PrinterFilled)),
          _cache[3] || (_cache[3] = _createTextVNode(" 传真: 86-021-56493782 "))
        ]),
        _createElementVNode("p", null, [
          _createVNode(_unref(CustomerServiceFilled)),
          _cache[4] || (_cache[4] = _createTextVNode(" 400服务热线：400-156-5866 "))
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "beian-info" }, [
      _createElementVNode("p", null, "沪 ICP备 18039351 号 ｜ 沪 ICP 备 18039351 号 -1")
    ], -1))
  ]))
}
}

})